import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const LifeStoryIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 7, width = 10, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 7 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M0.5 9V8.11111C0.5 7.63961 0.687301 7.18743 1.0207 6.85403C1.3541 6.52063 1.80628 6.33333 2.27778 6.33333H4.05556C4.52705 6.33333 4.97924 6.52063 5.31263 6.85403C5.64603 7.18743 5.83333 7.63961 5.83333 8.11111V9M1.38889 2.77778C1.38889 3.24927 1.57619 3.70146 1.90959 4.03486C2.24299 4.36825 2.69517 4.55556 3.16667 4.55556C3.63816 4.55556 4.09035 4.36825 4.42375 4.03486C4.75714 3.70146 4.94445 3.24927 4.94445 2.77778C4.94445 2.30628 4.75714 1.8541 4.42375 1.5207C4.09035 1.1873 3.63816 1 3.16667 1C2.69517 1 2.24299 1.1873 1.90959 1.5207C1.57619 1.8541 1.38889 2.30628 1.38889 2.77778Z"
          stroke="#D47F08"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
